import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
import { FlowVoiceCallBlockConfigSchema } from './config.js';
export var FlowVoiceBlockOutputType;
(function (FlowVoiceBlockOutputType) {
    FlowVoiceBlockOutputType["V1"] = "V1";
    FlowVoiceBlockOutputType["V2"] = "V2";
})(FlowVoiceBlockOutputType || (FlowVoiceBlockOutputType = {}));
export const FLOW_VOICE_CALL_BLOCK_TYPES = new Set([
    FlowBlockType.VoiceCall,
    FlowBlockType.VoiceCallV2,
]);
export const FlowVoiceCallV2BlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.VoiceCallV2),
    config: FlowVoiceCallBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.VoiceCallV2),
});
export const FlowVoiceCallV2ReturnDataSchema = z.looseObject({
    notableVoiceCall: z
        .looseObject({
        id: z.string(),
        created: z.string(),
        updated: z.string(),
        sessionId: z.string(),
        providerCallId: z.string(),
        type: z.string(),
        assistant: z.record(z.string(), z.unknown()),
        toPhoneNumber: z.string(),
        fromPhoneNumber: z.string(),
        callStartTime: z.string(),
        provider: z.string(),
        callEndTime: z.string().nullable().optional(),
        endedReason: z.string().nullable().optional(),
        summary: z.string().nullable().optional(),
        successEvaluation: z.string().nullable().optional(),
    })
        .optional(),
});
//# sourceMappingURL=configV2.js.map